// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by InsightsQueryParser.
export default class InsightsQueryListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by InsightsQueryParser#rootExpression.
	enterRootExpression(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#rootExpression.
	exitRootExpression(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#AndExpr.
	enterAndExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#AndExpr.
	exitAndExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#EqualExpr.
	enterEqualExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#EqualExpr.
	exitEqualExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#GreaterThanExpr.
	enterGreaterThanExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#GreaterThanExpr.
	exitGreaterThanExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#MultiplyExpr.
	enterMultiplyExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#MultiplyExpr.
	exitMultiplyExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#UnaryNotExpr.
	enterUnaryNotExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#UnaryNotExpr.
	exitUnaryNotExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#AddExpr.
	enterAddExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#AddExpr.
	exitAddExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#RaiseToExpr.
	enterRaiseToExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#RaiseToExpr.
	exitRaiseToExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#NotEqualExpr.
	enterNotEqualExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#NotEqualExpr.
	exitNotEqualExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#OrExpr.
	enterOrExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#OrExpr.
	exitOrExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#DivideExpr.
	enterDivideExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#DivideExpr.
	exitDivideExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#LessThanOrEqualExpr.
	enterLessThanOrEqualExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#LessThanOrEqualExpr.
	exitLessThanOrEqualExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#ConcatExpr.
	enterConcatExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#ConcatExpr.
	exitConcatExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#FunctionCallExpr.
	enterFunctionCallExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#FunctionCallExpr.
	exitFunctionCallExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#IdentifierExpr.
	enterIdentifierExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#IdentifierExpr.
	exitIdentifierExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#UnaryPlusExpr.
	enterUnaryPlusExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#UnaryPlusExpr.
	exitUnaryPlusExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#LiteralExpr.
	enterLiteralExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#LiteralExpr.
	exitLiteralExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#ParenthesizedExpr.
	enterParenthesizedExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#ParenthesizedExpr.
	exitParenthesizedExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#SubtractExpr.
	enterSubtractExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#SubtractExpr.
	exitSubtractExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#LessThanExpr.
	enterLessThanExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#LessThanExpr.
	exitLessThanExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#UnaryMinusExpr.
	enterUnaryMinusExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#UnaryMinusExpr.
	exitUnaryMinusExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#GreaterThanOrEqualExpr.
	enterGreaterThanOrEqualExpr(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#GreaterThanOrEqualExpr.
	exitGreaterThanOrEqualExpr(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#NumberLiteral.
	enterNumberLiteral(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#NumberLiteral.
	exitNumberLiteral(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#StringLiteral.
	enterStringLiteral(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#StringLiteral.
	exitStringLiteral(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#functionCall.
	enterFunctionCall(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#functionCall.
	exitFunctionCall(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#callArgs.
	enterCallArgs(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#callArgs.
	exitCallArgs(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#values.
	enterValues(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#values.
	exitValues(ctx) {
	}


	// Enter a parse tree produced by InsightsQueryParser#identifier.
	enterIdentifier(ctx) {
	}

	// Exit a parse tree produced by InsightsQueryParser#identifier.
	exitIdentifier(ctx) {
	}



}